import React, { Component } from 'react';
import { Grid } from 'react-bootstrap';
import { SESSION_SUCCESS } from '../redux/modules/auth';
import i18n from 'kodyl-js/i18n/react';
import BoligAgents from '../profile/boligagent';
import ErrorMessage from '../common/error-message';

@i18n
class VerifyBoligagent extends Component {
  constructor(props) {
    super(props);
    this.state = { loaded: null };
  }

  componentWillMount() {
    if (__CLIENT__) {
      const {
        verifyBoligagent,
        location: { query }
      } = this.props;
      verifyBoligagent(query.token).then(action => {
        if (action.error) {
          this.setState({ loaded: false });
        } else if (action.type === SESSION_SUCCESS) {
          this.setState({ loaded: true });
        }
        return action;
      });
    }
  }

  render() {
    const { loaded } = this.state;

    return (
      <Grid>
        {loaded === false ? (
          <ErrorMessage
            text={this.i18n(
              'We could not recognize you verification token. Make sure you type in the full address.'
            )}
          />
        ) : loaded === true ? (
          <BoligAgents />
        ) : (
          <h3>{this.i18n('Et øjeblik. Vi henter lige din BoligAgent...')}</h3>
        )}
      </Grid>
    );
  }
}

export default VerifyBoligagent;
